/**
 * @description Displays the sync SSN field that indicates if the personnel records should be synced based on matching
 *  SSN values
 */

import React from 'react';
import { useFormContext, Controller } from 'react-hook-form';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormHelperText from '@mui/material/FormHelperText';
import Switch from '@mui/material/Switch';

const SsnSyncField = () => {
  const { control } = useFormContext();

  return (
    <Controller
      name='syncOnSsn'
      control={control}
      render={({ field: { onChange, value } }) => (
        <FormControl fullWidth>
          <FormControlLabel
            control={<Switch onChange={(evt) => onChange(evt.target.checked)} checked={value} />}
            label='Sync on SSN'
          />
          <FormHelperText>
            Syncs all personnel updates to any personnel with the same Social Security Number
          </FormHelperText>
        </FormControl>
      )}
    />
  )
};

export default SsnSyncField;
